// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e05d47d","453":"e37bc9cd","455":"34e2e334","821":"ecce3aea","977":"19960fe2"}[chunkId] + ".chunk.js";
};